<script setup lang="ts">
import { useAuthStore, useUserStore } from './stores';
import Header from './components/Header/Header.vue';
import { watchEffect } from 'vue';
import bgSrc from './assets/imgs/bg.jpg'
import Loading from './components/General/Loading.vue';
import ClassFinished from './components/Notification/ClassFinished.vue';
import AppVersion from './components/General/AppVersion.vue';
import CopyRight from './components/General/CopyRight.vue';
import { UserRole } from './types/user';

const appStyle = {
  backgroundImage: `url(${bgSrc})`
}

const auth = useAuthStore()
const user = useUserStore()

watchEffect(async () => {
  if (auth.isAuthenticated) {
    user.getUserInfo()
  }
})
</script>

<template>
  <div class="h-screen !h-dvh flex flex-col bg-blue-900 bg-cover bg-center bg-fixed"
    :class="{ 'select-none': user.userRole === UserRole.student }" :style="appStyle">
    <Header />
    <div class="flex-1 overflow-auto p-3 pb-0">
      <router-view />
    </div>
    <CopyRight />
  </div>
  <Loading />
  <ClassFinished />
  <AppVersion />
</template>